import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doPROJECT_SET, doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_WORKSPACE_UPDATE = 'REQUEST_PROJECT_WORKSPACE_UPDATE'
export const doREQUEST_PROJECT_WORKSPACE_UPDATE = createDoRequestAction(REQUEST_PROJECT_WORKSPACE_UPDATE)

export const requestProjectWorkspaceUpdateActionCreators = {
  doREQUEST_PROJECT_WORKSPACE_UPDATE,
}

export function* requestProjectWorkspaceUpdate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectWorkspaceUpdate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        workspaceId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_WORKSPACE_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, workspaceId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-workspace-update`,
    accessToken,
    data: {
      projectId,
      workspaceId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_WORKSPACE_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-workspace-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_WORKSPACE_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectWorkspaceUpdateSaga() {
  yield takeEvery(REQUEST_PROJECT_WORKSPACE_UPDATE, requestProjectWorkspaceUpdate)
}
